<div class="video-modal">
    <iframe class="mfp-iframe" src="//www.youtube.com/embed/vBPgmASQ1A0?autoplay=1" frameBorder="0" allowFullScreen=""
        title="youtube"></iframe>
    <button type="button" class="close" (click)="closeModal()" autofocus=false><span><i
                class="icon-close"></i></span></button>
</div>